'use strict';
accountsReceivableSetupController.$inject = [
	'$scope',
	'$rootScope',
	'$location',
	'$q',
	'$uibModal',
	'$filter',
	'authService',
	'arCategoryService',
	'arItemService',
	'arBillingGroupService',
	'userService',
	'accountStructureService',
	'customerService',
	'siteService',
	'utilsService',
	'USER_CLAIMS',
];
angular.module('schoolLinqApp').controller('accountsReceivableSetupController', accountsReceivableSetupController);

function accountsReceivableSetupController(
	$scope,
	$rootScope,
	$location,
	$q,
	$uibModal,
	$filter,
	authService,
	arCategoryService,
	arItemService,
	arBillingGroupService,
	userService,
	accountStructureService,
	customerService,
	siteService,
	utilsService,
	USER_CLAIMS
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.$watch(
		'vm.arCategories.arCategory.selectedUsers',
		function (selectedUsers) {
			$scope.vm.arCategories.arCategory.numberOfUsersSelected = selectedUsers.filter(function (value) {
				return value.Selected;
			}).length;

			if ($scope.vm.arCategories.arCategory.numberOfUsersSelected === $scope.vm.arCategories.arCategory.selectedUsers.length) {
				$scope.vm.arCategories.arCategory.allUsersSelected = true;
			} else {
				$scope.vm.arCategories.arCategory.allUsersSelected = false;
			}
		},
		true
	);

	$scope.$watch(
		'vm.arBillingGroups.arBillingGroup.selectedCustomers',
		function (selectedBillingGroups) {
			$scope.vm.arBillingGroups.arBillingGroup.numberOfSelectedCustomers = selectedBillingGroups.filter(function (value) {
				return value.Selected;
			}).length;

			if (
				$scope.vm.arBillingGroups.arBillingGroup.numberOfSelectedCustomers ===
				$scope.vm.arBillingGroups.arBillingGroup.selectedCustomers.length
			) {
				$scope.vm.arBillingGroups.arBillingGroup.allCustomersSelected = true;
			} else {
				$scope.vm.arBillingGroups.arBillingGroup.allCustomersSelected = false;
			}
		},
		true
	);

	$scope.loadingPromise = $q.all([
		$scope.vm.loadCategories($scope.vm),
		$scope.vm.loadUsers($scope.vm),
		$scope.vm.loadARItems($scope.vm),
		$scope.vm.loadARBillingGroups($scope.vm),
		$scope.vm.loadCustomers($scope.vm),
	]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,

			arCategories: {
				arCategory: {
					Id: 0,
					Active: true,
					Description: '',
					selectedUsers: [],
					userPaging: {
						userSearch: '',
						userBarLimit: 12,
						userStartIndex: 0,
					},
					numberOfUsersSelected: 0,
					allUsersSelected: false,
					canDelete: false,
					numberOfItems: 0,
				},
				arCategories: [],
				filter: {
					search: '',
				},
				barLimit: 12,
				startIndex: 0,
			},
			arItems: {
				arItem: {
					Active: true,
					Id: 0,
					ItemCode: '',
					Description: '',
					Price: 0.0,
					CategoryId: null,
					ts: null,
				},
				arItems: [],
				filter: {
					search: '',
				},
				startIndex: 0,
				barLimit: 12,
			},
			arBillingGroups: {
				arBillingGroup: {
					Id: 0,
					CategoryId: null,
					Description: '',
					Active: true,
					ts: null,
					selectedCustomers: [],
					customerPaging: {
						customerSearch: '',
						customerStartIndex: 0,
						customerBarLimit: 12,
					},
					numberOfSelectedCustomers: 0,
					allCustomersSelected: false,
				},
				arBillingGroups: [],
				filter: {
					search: '',
				},
				startIndex: 0,
				barLimit: 12,
			},
			errors: null,
			currentUserName: authService.authentication.userName,
			tab: 'Categories',
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'Setup', 'receivable'),
		};

		/* Billing Group Functions */
		function loadARBillingGroups(model) {
			$scope.loadingPromise = arBillingGroupService.getARBillingGroups().then(_.partial(finishedLoadingBillingGroups, model));

			function finishedLoadingBillingGroups(model, response) {
				model.arBillingGroups.arBillingGroups = response.data.arBillingGroups;
				return angular.noop;
			}
		}

		function loadCustomers(model) {
			$scope.loadingPromise = customerService.getCustomers().then(_.partial(finishedLoadingCustomers, model));

			function finishedLoadingCustomers(model, response) {
				for (var index = 0; index < response.data.customers.length; index++) {
					model.arBillingGroups.arBillingGroup.selectedCustomers.push({
						Id: response.data.customers[index].Id,
						CustomerName: response.data.customers[index].CustomerName,
						Selected: true,
					});
				}

				return angular.noop;
			}
		}

		function editARBillingGroup(model, Id) {
			$scope.loadingPromise = arBillingGroupService.getARBillingGroup(Id).then(_.partial(finishedLoadingARBillingGroup, model));

			function finishedLoadingARBillingGroup(model, response) {
				model.resetARBillingGroupForm();

				var loadedBillingGroup = response.data.arBillingGroup;
				model.arBillingGroups.arBillingGroup.Id = loadedBillingGroup.Id;
				model.arBillingGroups.arBillingGroup.CategoryId = loadedBillingGroup.CategoryId;
				model.arBillingGroups.arBillingGroup.Description = loadedBillingGroup.Description;
				model.arBillingGroups.arBillingGroup.Active = loadedBillingGroup.Active;

				var loadedSelectedCustomerIds = _.pluck(loadedBillingGroup.AR_BillingGroupCustomer, 'CustomerId');

				for (var index = 0; index < model.arBillingGroups.arBillingGroup.selectedCustomers.length; index++) {
					var isSelected = false;
					if (loadedSelectedCustomerIds.indexOf(model.arBillingGroups.arBillingGroup.selectedCustomers[index].Id) >= 0) {
						isSelected = true;
					}
					model.arBillingGroups.arBillingGroup.selectedCustomers[index].Selected = isSelected;
				}

				return model.addOrEditARBillingGroup();
			}
		}

		function selectAllCustomersInAddBillingGroupModal(model) {
			var shouldSelect = !model.arBillingGroups.arBillingGroup.allCustomersSelected;

			for (var index = 0; index < model.arBillingGroups.arBillingGroup.selectedCustomers.length; index++) {
				model.arBillingGroups.arBillingGroup.selectedCustomers[index].Selected = shouldSelect;
			}
		}

		function resetARBillingGroupForm(model) {
			model.arBillingGroups.arBillingGroup.Id = 0;
			model.arBillingGroups.arBillingGroup.CategoryId = null;
			model.arBillingGroups.arBillingGroup.Description = '';
			model.arBillingGroups.arBillingGroup.Active = true;
			model.arBillingGroups.arBillingGroup.customerPaging.customerSearch = '';

			for (var index = 0; index < model.arBillingGroups.arBillingGroup.selectedCustomers.length; index++) {
				model.arBillingGroups.arBillingGroup.selectedCustomers[index].Selected = false;
			}
		}

		function addOrEditARBillingGroup(model) {
			if (model.arBillingGroups.arBillingGroup.Id === 0) {
				resetARBillingGroupForm(model);
			}

			$uibModal
				.open({
					template: require('@ajs/templates/fund/arbillinggroup-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					size: 'topMoveUp',
					controller: [
						'$scope',
						'$uibModalInstance',
						'arBillingGroupService',
						function ($scope, modalInstance, arBillingGroupService) {
							angular.extend($scope, {
								cancel: function () {
									resetARBillingGroupForm(model);
									modalInstance.close();
								},
								save: function () {
									if (!$scope.addEditBillingGroupForm.$valid) return false;

									$scope.vm.arBillingGroups.arBillingGroup.AssociatedCustomerIds = [];
									for (var index = 0; index < $scope.vm.arBillingGroups.arBillingGroup.selectedCustomers.length; index++) {
										if ($scope.vm.arBillingGroups.arBillingGroup.selectedCustomers[index].Selected) {
											$scope.vm.arBillingGroups.arBillingGroup.AssociatedCustomerIds.push(
												$scope.vm.arBillingGroups.arBillingGroup.selectedCustomers[index].Id
											);
										}
									}

									if ($scope.vm.arBillingGroups.arBillingGroup.Id === 0) {
										$scope.savingPromise = arBillingGroupService
											.addARBillingGroup($scope.vm.arBillingGroups.arBillingGroup)
											.then(function (response) {
												finishAddingOrEditing(model, modalInstance, response);
											});
									} else {
										$scope.savingPromise = arBillingGroupService
											.updateARBillingGroup($scope.vm.arBillingGroups.arBillingGroup)
											.then(function (response) {
												finishAddingOrEditing(model, modalInstance, response);
											});
									}

									function finishAddingOrEditing(model, modalInstance, response) {
										if (response.data.isValid) {
											resetARBillingGroupForm(model);
											modalInstance.close(response.data.Id);
										} else {
											resetARBillingGroupForm(model);
											modalInstance.close(response.data.Id);
											$scope.errors = response.data.errors;
										}
									}
								},
								delete: function (id) {
									$uibModal
										.open({
											template: require('@ajs/templates/fund/arbillinggroup-delete-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												'arBillingGroupService',
												function ($scope, modalInstance, arBillingGroupService) {
													angular.extend($scope, {
														cancel: function () {
															modalInstance.close();
														},
														delete: function () {
															$scope.deletingPromise = arBillingGroupService
																.deleteARBillingGroup(id)
																.then(function (response) {
																	if (response.data.isValid) {
																		modalInstance.close(true);
																	} else {
																		$scope.errors = response.data.errors;
																	}
																});
														},
													});
												},
											],
										})
										.result.then(function (reload) {
											if (reload) {
												modalInstance.close(1);
											}
										});
								},
							});
						},
					],
				})
				.result.then(function (Id) {
					if (Id) {
						loadARBillingGroups($scope.vm);
						resetARBillingGroupForm(model);
					}
				});
		}

		/* Item Functions */
		function loadARItems(model) {
			$scope.loadingPromise = arItemService.getARItems().then(_.partial(finishedLoadingARItems, model));

			function finishedLoadingARItems(model, response) {
				model.arItems.arItems = response.data.arItems;
				return angular.noop;
			}
		}

		function resetARItemForm(model) {
			model.arItems.arItem.Active = true;
			model.arItems.arItem.Id = 0;
			model.arItems.arItem.ItemCode = '';
			model.arItems.arItem.Description = '';
			model.arItems.arItem.Price = 0.0;
			model.arItems.arItem.CategoryId = null;
			model.arItems.arItem.ts = null;
		}

		function editARItem(model, Id) {
			$scope.loadingPromise = arItemService.getARItem(Id).then(_.partial(finishedLoadingARItem, model));

			function finishedLoadingARItem(model, response) {
				model.resetARItemForm();

				model.arItems.arItem = response.data.arItem;

				return model.addOrEditARItem();
			}
		}

		function addOrEditARItem(model) {
			if (model.arItems.arItem.Id === 0) {
				resetARItemForm(model);
			}

			$uibModal
				.open({
					template: require('@ajs/templates/fund/aritem-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'arItemService',
						function ($scope, modalInstance, arItemService) {
							angular.extend($scope, {
								cancel: function () {
									resetARItemForm(model);
									modalInstance.close();
								},
								save: function () {
									if (!$scope.addEditItemForm.$valid) return false;

									if ($scope.vm.arItems.arItem.Id === 0) {
										$scope.savingPromise = arItemService.addARItem($scope.vm.arItems.arItem).then(function (response) {
											finishAddingOrEditing(model, modalInstance, response);
										});
									} else {
										$scope.savingPromise = arItemService.updateARItem($scope.vm.arItems.arItem).then(function (response) {
											finishAddingOrEditing(model, modalInstance, response);
										});
									}

									function finishAddingOrEditing(model, modalInstance, response) {
										if (response.data.isValid) {
											resetARItemForm(model);
											modalInstance.close(response.data.Id);
										} else {
											resetARItemForm(model);
											modalInstance.close(response.data.Id);
											$scope.errors = response.data.errors;
										}
									}
								},
								delete: function (id) {
									$uibModal
										.open({
											template: require('@ajs/templates/fund/aritem-delete-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												'arItemService',
												function ($scope, modalInstance, arItemService) {
													angular.extend($scope, {
														cancel: function () {
															modalInstance.close();
														},
														delete: function () {
															$scope.deletingPromise = arItemService.deleteARItem(id).then(function (response) {
																if (response.data.isValid) {
																	modalInstance.close(true);
																} else {
																	$scope.errors = response.data.errors;
																}
															});
														},
													});
												},
											],
										})
										.result.then(function (reload) {
											if (reload) {
												modalInstance.close(1);
											}
										});
								},
							});
						},
					],
				})
				.result.then(function (Id) {
					if (Id) {
						resetARItemForm(model);
						loadARItems($scope.vm);
					}
				});
		}

		/* Category Functions */
		function arCategoryAddEditCheckDisplay(model, numberOfItems) {
			if (model.arCategories.arCategory.Id === 0) {
				model.arCategories.arCategory.Active = !model.arCategories.arCategory.Active;
			} else {
				if (!model.arCategories.arCategory.Active) {
					model.arCategories.arCategory.Active = true;
					return;
				}
				$uibModal.open({
					template: require('@ajs/templates/fund/arcategory-confirminactive-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								hideCategory: function () {
									model.arCategories.arCategory.Active = false;
									modalInstance.close();
								},
							});
						},
					],
				});
			}
		}

		function loadCategories(model) {
			$scope.loadingPromise = arCategoryService.getARCategories().then(_.partial(finishedLoadingARCategories, model));

			function finishedLoadingARCategories(model, response) {
				model.arCategories.arCategories = response.data.categories;

				return angular.noop;
			}
		}

		function resetAddCategoryForm(model) {
			model.arCategories.arCategory.Id = 0;
			model.arCategories.arCategory.Description = '';
			model.arCategories.arCategory.Active = true;
			model.arCategories.arCategory.canDelete = false;
			model.arCategories.arCategory.numberOfItems = 0;
			model.arCategories.arCategory.userPaging.userSearch = '';

			for (var index = 0; index < model.arCategories.arCategory.selectedUsers.length; index++) {
				model.arCategories.arCategory.selectedUsers[index].Selected =
					model.currentUserName === model.arCategories.arCategory.selectedUsers[index].UserName ? true : false;
			}
		}

		function addARCategory(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/arcategory-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					size: 'topMoveUp',
					controller: [
						'$scope',
						'$uibModalInstance',
						'arCategoryService',
						function ($scope, modalInstance, arCategoryService) {
							angular.extend($scope, {
								cancel: function () {
									resetAddCategoryForm(model);
									modalInstance.close();
								},
								save: function () {
									if (!$scope.addCategoryForm.$valid) return false;

									model.arCategories.arCategory.SelectedUserIds = [];
									for (var index = 0; index < model.arCategories.arCategory.selectedUsers.length; index++) {
										if (model.arCategories.arCategory.selectedUsers[index].Selected) {
											model.arCategories.arCategory.SelectedUserIds.push(model.arCategories.arCategory.selectedUsers[index].Id);
										}
									}

									if ($scope.vm.arCategories.arCategory.Id === 0) {
										$scope.savingPromise = arCategoryService
											.addARCategory($scope.vm.arCategories.arCategory)
											.then(function (response) {
												finishAddingOrEditing(model, modalInstance, response);
											});
									} else {
										$scope.savingPromise = arCategoryService
											.updateARCategory($scope.vm.arCategories.arCategory)
											.then(function (response) {
												finishAddingOrEditing(model, modalInstance, response);
											});
									}

									function finishAddingOrEditing(model, modalInstance, response) {
										if (response.data.isValid) {
											resetAddCategoryForm(model);
											modalInstance.close(response.data.isValid);
										} else {
											resetAddCategoryForm(model);
											modalInstance.close(response.data.isValid);
											$scope.errors = response.data.errors;
										}
									}
								},
								delete: function (id) {
									$uibModal
										.open({
											template: require('@ajs/templates/fund/arcategory-delete-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												'arCategoryService',
												function ($scope, modalInstance, arCategoryService) {
													angular.extend($scope, {
														cancel: function () {
															modalInstance.close();
														},
														delete: function () {
															$scope.deletingPromise = arCategoryService.deleteARCategory(id).then(function (response) {
																if (response.data.isValid) {
																	modalInstance.close(true);
																} else {
																	$scope.errors = response.data.errors;
																}
															});
														},
													});
												},
											],
										})
										.result.then(function (reload) {
											if (reload) {
												modalInstance.close(1);
											}
										});
								},
							});
						},
					],
				})
				.result.then(function (isValid) {
					if (isValid) {
						model.loadCategories($scope.vm);
						model.loadARItems($scope.vm);
						model.resetAddCategoryForm(model);
					}
				});
		}

		function editARCategory(model, id) {
			$scope.loadingPromise = arCategoryService.getARCategory(id).then(_.partial(finishedLoadingCategory, model));

			function finishedLoadingCategory(model, response) {
				model.resetAddCategoryForm();

				model.arCategories.arCategory.canDelete = response.data.arCategory.CanDelete;
				model.arCategories.arCategory.Id = response.data.arCategory.Id;
				model.arCategories.arCategory.Active = response.data.arCategory.Active;
				model.arCategories.arCategory.Description = response.data.arCategory.Description;
				model.arCategories.arCategory.numberOfItems = response.data.arCategory.NumberOfItems;

				var userIds = response.data.arCategory.SelectedUserIds;

				for (var index = 0; index < model.arCategories.arCategory.selectedUsers.length; index++) {
					var id = model.arCategories.arCategory.selectedUsers[index].Id;
					if (userIds.indexOf(id) >= 0) {
						model.arCategories.arCategory.selectedUsers[index].Selected = true;
					} else {
						model.arCategories.arCategory.selectedUsers[index].Selected = false;
					}
				}

				return model.addARCategory();
			}
		}

		/* Users Functions */
		function loadUsers(model) {
			return userService.list().then(_.partial(finishedLoadingUsers, model));

			function finishedLoadingUsers(model, response) {
				model.arCategories.arCategory.selectedUsers = [];
				// do not show global admin users - they now have access to all categories anyway
				var users = _.reject(response.data.users, { RoleName: 'Global Admin' });

				_.each(_.sortBy(users, 'UserName'), function (user) {
					model.arCategories.arCategory.selectedUsers.push({
						UserName: user.UserName,
						Id: user.Id,
						Selected: user.UserName === model.currentUserName ? true : false,
					});
				});

				return angular.noop;
			}
		}

		function selectAllUsersInAddModal(model) {
			var newSelectedValue = !model.arCategories.arCategory.allUsersSelected;
			for (var index = 0; index < model.arCategories.arCategory.selectedUsers.length; index++) {
				model.arCategories.arCategory.selectedUsers[index].Selected = newSelectedValue;
			}
		}

		function filterSelectedUsers(model, user) {
			return user.Selected;
		}

		function changeTab(model, tab) {
			model.tab = tab;
		}

		return angular.extend(model, {
			changeTab: _.partial(changeTab, model),
			loadCategories: _.partial(loadCategories, model),
			loadUsers: _.partial(loadUsers, model),
			filterSelectedUsers: _.partial(filterSelectedUsers, model),
			selectAllUsersInAddModal: _.partial(selectAllUsersInAddModal, model),
			editARCategory: _.partial(editARCategory, model),
			resetAddCategoryForm: _.partial(resetAddCategoryForm, model),
			addARCategory: _.partial(addARCategory, model),
			addOrEditARItem: _.partial(addOrEditARItem, model),
			loadARItems: _.partial(loadARItems, model),
			editARItem: _.partial(editARItem, model),
			resetARItemForm: _.partial(resetARItemForm, model),
			addOrEditARBillingGroup: _.partial(addOrEditARBillingGroup, model),
			editARBillingGroup: _.partial(editARBillingGroup, model),
			loadARBillingGroups: _.partial(loadARBillingGroups, model),
			loadCustomers: _.partial(loadCustomers, model),
			resetARBillingGroupForm: _.partial(resetARBillingGroupForm, model),
			selectAllCustomersInAddBillingGroupModal: _.partial(selectAllCustomersInAddBillingGroupModal, model),
			arCategoryAddEditCheckDisplay: _.partial(arCategoryAddEditCheckDisplay, model),
		});
	}
}

angular.module('schoolLinqApp').directive('validateDuplicateCategory', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attr, ngModel) {
			ngModel.$parsers.unshift(function (value) {
				var categoryId = parseInt(attr.validateDuplicateCategory);

				var numberOfMatches = scope.$parent.vm.arCategories.arCategories.filter(function (row) {
					return row.Description.toLowerCase().trim() === value.toLowerCase().trim() && row.Id !== categoryId;
				}).length;

				var isValid;
				if (numberOfMatches > 0) {
					isValid = false;
				} else {
					isValid = true;
				}

				ngModel.$setValidity('validateDuplicateARCategory', isValid);
				return isValid ? value : undefined;
			});
		},
	};
});

angular.module('schoolLinqApp').directive('validateDuplicateItemCode', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attr, ngModel) {
			ngModel.$parsers.unshift(function (value) {
				var itemId = parseInt(attr.validateDuplicateItemCode);

				var numberOfMatches = scope.$parent.vm.arItems.arItems.filter(function (row) {
					return row.ItemCode.toLowerCase().trim() === value.toLowerCase().trim() && row.Id !== itemId;
				}).length;

				var isValid;
				if (numberOfMatches > 0) {
					isValid = false;
				} else {
					isValid = true;
				}

				ngModel.$setValidity('validateDuplicateItemCode', isValid);
				return isValid ? value : undefined;
			});
		},
	};
});

angular.module('schoolLinqApp').directive('validateDuplicateBillingGroupDescription', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attr, ngModel) {
			ngModel.$parsers.unshift(function (value) {
				var itemId = parseInt(attr.validateDuplicateBillingGroupDescription);

				var numberOfMatches = scope.$parent.vm.arBillingGroups.arBillingGroups.filter(function (row) {
					return row.Description.toLowerCase().trim() === value.toLowerCase().trim() && row.Id !== itemId;
				}).length;

				var isValid;
				if (numberOfMatches > 0) {
					isValid = false;
				} else {
					isValid = true;
				}

				ngModel.$setValidity('validateDuplicateBillingGroupDescription', isValid);
				return isValid ? value : undefined;
			});
		},
	};
});
